<template>
  <v-container>
    <v-form ref="form">
      <v-card class="px-2">
        <input
          id="user-id"
          type="hidden"
          v-model="processo.usuario"
        >
        <input
          id="processo-uuid"
          type="hidden"
          v-model="processo.uuid"
        >
        <input
          id="processo-id"
          type="hidden"
          v-model="processo.id"
        >
        <v-row>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="codigo"
              label="Código"
              dense
              outlined
              @change="loadProcesso()"
            >
              <v-btn
                class="btn-outer-right pa-0"
                slot="append"
                color="success"
                tile
                @click.prevent="loadDialog"
              >
                <v-icon
                  class="mx-0"
                  color="white"
                >
                  mdi-magnify
                </v-icon>
              </v-btn>
            </v-text-field>
          </v-col>
          <v-col
            colls="12"
            lg="3"
            md="6"
            sm="12"
            v-if="!code"
          >
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-mask="datacad"
                  v-model="data_cad"
                  label="Data do cadastro.:"
                  dense
                  outlined
                  @blur="mudaDataA"
                >
                  <v-icon
                    slot="append"
                    color="success"
                    large
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-calendar
                  </v-icon>
                </v-text-field>
              </template>
              <v-date-picker
                locale="pt-br"
                v-model="date0"
                @input="dateA"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            md="3"
            lg="3"
            v-if="code"
          >
            <v-checkbox
              class="mb-2"
              v-model="processo.inativar"
              label="Inativar processo?"
              color="success"
              :readonly="mode === 'delete'"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            colls="12"
            lg="2"
            md="3"
            sm="12"
          >
            <v-text-field
              label="Protocolo.:"
              v-model="processo.processo"
              required
              dense
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col
            colls="12"
            lg="4"
            md="4"
            sm="12"
          >
            <v-autocomplete
              label="Local de origem do processo:"
              v-model="processo.local"
              :items="localProcesso"
              clearable
              dense
              outlined
            >
            </v-autocomplete>
          </v-col>
          <v-col
            colls="12"
            lg="2"
            md="5"
            sm="12"
          >
            <v-text-field
              label="Processo ou projeto.:"
              v-model="proc"
              required
              :readonly="mode === 'delete'"
              :disabled="!processo.local"
              dense
              outlined
              @change="loadOrigem()"
            >
              <v-btn
                class="btn-outer-right pa-0"
                slot="append"
                color="success"
                tile
                @click.prevent="loadDialogOrigem"
              >
                <v-icon
                  class="mx-0"
                  color="white"
                >
                  mdi-magnify
                </v-icon>
              </v-btn>
            </v-text-field>
          </v-col>
          <v-col
            colls="12"
            lg="2"
            md="3"
            sm="12"
          >
            <v-text-field
              label="Ano do processo.:"
              v-model="anoProc"
              required
              :readonly="mode === 'delete'"
              :disabled="!processo.local"
              dense
              outlined
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-card flat>
          <v-tabs
            background-color="primary"
            dark
            v-model="tabs"
            class="mb-4"
          >
            <v-tab>
              <v-icon class="mr-1">
              </v-icon>
              Geral
            </v-tab>
            <v-tab
              @click="loadAnexos"
              :disabled="!processo.id"
            >
              <v-icon class="mr-1">
                mdi-paperclip
              </v-icon>
              Anexos
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <v-card
                flat
                class="py-2"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                    class="mr-0 pr-0"
                  >
                    <v-text-field
                      class="codigo mr-0"
                      v-model="processo.uid_interessado"
                      label="Código..."
                      dense
                      outlined
                      flat
                      @change="loadInteressadoPessoaId()"
                    >
                      <v-btn
                        class="btn-outer pa-0"
                        slot="append"
                        color="success"
                        tile
                        @click="loadFtAutor"
                      >
                        <v-icon
                          class="mx-0"
                          color="white"
                        >
                          mdi-magnify
                        </v-icon>
                      </v-btn>
                      <v-btn
                        class="btn-outer-right pa-0"
                        slot="append"
                        color="light"
                        tile
                        @click="loadAddPessoa"
                      >
                        <v-icon
                          class="mx-0"
                          color="black"
                        >
                          mdi-plus
                        </v-icon>
                      </v-btn>
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    lg="6"
                    class="ml-0 pl-0"
                  >
                    <v-text-field
                      class="v-busca-nome ml-0"
                      v-model="processo.interessado"
                      :loading="loading"
                      aria-autocomplete="none"
                      :search-input.sync="search"
                      label="Interessado"
                      outlined
                      dense
                      @keyup.native="loadSeachI()"
                    >
                      <v-icon
                        slot="append"
                        color="black"
                        v-if="processo.interessado"
                        @click.prevent="clInteressado"
                      >
                        mdi-close
                      </v-icon>
                    </v-text-field>
                    <v-card
                      v-show="listarI === 'sim'"
                      class="my-0 py-0"
                    >
                      <ul class="filtro">
                        <li
                          v-for="item in itemsI"
                          :key="item.uid_pessoa"
                        >
                          <a @click="loadInteressadoPessoaId( item, 'novo' )"> {{ item.razao }} - {{ item.cgc_txt }}</a>
                        </li>
                      </ul>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    colls="12"
                    lg="4"
                    md="5"
                    sm="12"
                  >
                    <v-autocomplete
                      label="Assunto:"
                      v-model="processo.uid_assunto"
                      :items="assuntos"
                      clearable
                      dense
                      outlined
                      @change="loadSubassunto()"
                    >
                      <v-btn
                        class="btn-outer pa-0"
                        slot="append"
                        color="success"
                        tile
                        @click="loadFtAutor"
                      >
                        <v-icon
                          class="mx-0"
                          color="white"
                        >
                          mdi-magnify
                        </v-icon>
                      </v-btn>
                      <v-btn
                        class="btn-outer-right pa-0"
                        slot="append"
                        color="light"
                        tile
                        @click="loadAddAssunto"
                      >
                        <v-icon
                          class="mx-0"
                          color="black"
                        >
                          mdi-plus
                        </v-icon>
                      </v-btn>
                    </v-autocomplete>
                  </v-col>
                  <v-col
                    colls="12"
                    lg="4"
                    md="5"
                    sm="12"
                  >
                    <v-autocomplete
                      label="Subassunto:"
                      v-model="processo.uid_subassunto"
                      :items="subassuntos"
                      :disabled="!processo.uid_assunto"
                      clearable
                      dense
                      outlined
                    >
                      <v-btn
                        class="btn-outer pa-0"
                        slot="append"
                        color="success"
                        tile
                        @click="loadFtAutor"
                      >
                        <v-icon
                          class="mx-0"
                          color="white"
                        >
                          mdi-magnify
                        </v-icon>
                      </v-btn>
                      <v-btn
                        class="btn-outer-right pa-0"
                        slot="append"
                        color="light"
                        tile
                        @click="loadAddSubassunto"
                      >
                        <v-icon
                          class="mx-0"
                          color="black"
                        >
                          mdi-plus
                        </v-icon>
                      </v-btn>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                    class="mr-0 pr-0"
                  >
                    <v-text-field
                      class="codigo mr-0"
                      v-model="processo.uid_autor"
                      label="Código..."
                      dense
                      outlined
                      flat
                      @change="loadAutorPessoaId()"
                    >
                      <v-btn
                        class="btn-outer pa-0"
                        slot="append"
                        color="success"
                        tile
                        @click="loadFtPessoa"
                      >
                        <v-icon
                          class="mx-0"
                          color="white"
                        >
                          mdi-magnify
                        </v-icon>
                      </v-btn>
                      <v-btn
                        class="btn-outer-right pa-0"
                        slot="append"
                        color="light"
                        tile
                        @click="loadAddPessoa"
                      >
                        <v-icon
                          class="mx-0"
                          color="black"
                        >
                          mdi-plus
                        </v-icon>
                      </v-btn>
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    lg="6"
                    class="ml-0 pl-0"
                  >
                    <v-text-field
                      class="v-busca-nome ml-0"
                      v-model="processo.autor"
                      :loading="loading"
                      aria-autocomplete="none"
                      :search-input.sync="search"
                      label="Autor"
                      outlined
                      dense
                      @keyup.native="loadSeachA()"
                    >
                      <v-icon
                        v-if="processo.autor"
                        slot="append"
                        color="black"
                        @click.prevent="clAutor"
                      >
                        mdi-close
                      </v-icon>
                    </v-text-field>
                    <v-card
                      v-show="listarA === 'sim'"
                      class="my-0 py-0"
                    >
                      <ul class="filtro">
                        <li
                          v-for="item in itemsA"
                          :key="item.uid_pessoa"
                        >
                          <a @click="loadAutorPessoaId( item, 'novo' )"> {{ item.razao }} - {{ item.cgc_txt }}</a>
                        </li>
                      </ul>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    colls="12"
                    lg="4"
                    md="5"
                    sm="12"
                  >
                    <v-autocomplete
                      label="Situação:"
                      v-model="processo.uid_situacao"
                      :items="situacoes"
                      clearable
                      dense
                      outlined
                    >
                      <v-btn
                        class="btn-outer pa-0"
                        slot="append"
                        color="success"
                        tile
                        @click="loadFtAutor"
                      >
                        <v-icon
                          class="mx-0"
                          color="white"
                        >
                          mdi-magnify
                        </v-icon>
                      </v-btn>
                      <v-btn
                        class="btn-outer-right pa-0"
                        slot="append"
                        color="light"
                        tile
                        @click="loadAddSituacao"
                      >
                        <v-icon
                          class="mx-0"
                          color="black"
                        >
                          mdi-plus
                        </v-icon>
                      </v-btn>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row class="mb-2">
                  <v-col colls="12">
                    <v-card class="px-0 mb-2">
                      <v-card-subtitle class="my-0 py-0">Observações</v-card-subtitle>
                      <ckeditor
                        :editor="editor"
                        v-model="ementa"
                        :config="editorConfig"
                        :readonly="mode === 'delete'"
                      ></ckeditor>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card
                      flat
                      class="py-2"
                    >
                      <v-data-table
                        :headers="headerAnexo"
                        :items="anexos"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadAnexo(item, mode='update')"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="loadAnexo(item, mode='delete')"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-card-actions class="justify-end">
                        <v-btn
                          color="success"
                          class="ml-1 mb-3"
                          v-if="code"
                          @click="loadModalAnexo"
                        >
                          <v-icon left>
                            mdi-archive-arrow-up-outline
                          </v-icon>
                          Adicionar
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
          <v-card-actions>
            <v-row class="mt-1">
              <v-col
                cols="12"
                md="6"
              >
                <v-btn
                  color="success"
                  class="ml-1 mr-4"
                  v-if="mode === 'save'"
                  @click.prevent="save"
                >
                  <v-icon left>
                    mdi-content-save-outline
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="success"
                  class="ml-1 mr-4"
                  v-if="mode === 'update'"
                  @click.prevent="save"
                >
                  <v-icon left>
                    mdi-content-save-edit-outline
                  </v-icon>
                  Atualizar
                </v-btn>
                <v-btn
                  color="secondary"
                  class="mr-4"
                  @click="reset"
                >
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                  Limpar
                </v-btn>
                <v-btn
                  v-if="processo.id"
                  color="error"
                  class="mr-4"
                  @click="remove"
                >
                  <v-icon left>
                    mdi-trash-can-outline
                  </v-icon>
                  Deletar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
        <v-container>
          <v-dialog
            v-model="dialogFilterOrigem"
            transition="dialog-bottom-transition"
            fullscreen
          >
            <template v-slot:default="dialogFilterOrigem">
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                >
                  Pesquisar
                </v-toolbar>
                <v-card-title>
                  <v-text-field
                    class="search"
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar"
                    single-line
                    hide-details
                  >
                  </v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headersOrig"
                  :items="origens"
                  :search="search"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      large
                      color="success"
                      class="mr-2"
                      @click.prevent="loadOrigem(item)"
                    >
                      mdi-arrow-down-bold-box
                    </v-icon>
                  </template>
                </v-data-table>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="error"
                    @click="dialogFilterOrigem.value = false"
                  >Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-container>
        <v-container>
          <v-dialog
            v-model="dialogFilter"
            transition="dialog-bottom-transition"
            fullscreen
          >
            <template v-slot:default="dialogFilter">
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                >
                  Pesquisar
                </v-toolbar>
                <v-card-title>
                  <v-text-field
                    class="search"
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar"
                    single-line
                    hide-details
                  >
                  </v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headersProc"
                  :items="processos"
                  :search="search"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      large
                      color="success"
                      class="mr-2"
                      @click.prevent="loadProcesso(item, mode='update')"
                    >
                      mdi-arrow-down-bold-box
                    </v-icon>
                  </template>
                </v-data-table>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="error"
                    @click="dialogFilter.value = false"
                  >Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-container>
        <!-- Dialog de assunto -->
        <v-container>
          <v-dialog
            v-model="DialogAssunto"
            transition="dialog-top-transition"
            persistent
          >
            <v-card tile>
              <v-toolbar
                color="primary"
                dark
                class="mb-2"
              >
                Adicionar ou editar assuntos
              </v-toolbar>
              <div class="logo-foto ml-4 mt-5">
                <v-form>
                  <input
                    id="user-id"
                    type="hidden"
                    v-model="assunto.usuario"
                  />
                  <input
                    id="assunto-id"
                    type="hidden"
                    v-model="assunto.id"
                  />
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="code"
                        label="Código"
                        dense
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      colls="12"
                      lg="3"
                      md="4"
                      v-if="assunto.id"
                    >
                      <v-checkbox
                        v-model="assunto.inativar"
                        label="Inativar Assunto?"
                        color="success"
                        class="mt-4"
                      >
                      </v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="5"
                      lg="6"
                    >
                      <v-text-field
                        v-model="assunto.assunto"
                        type="text"
                        label="Assunto"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="5"
                      lg="4"
                    >
                      <v-autocomplete
                        label="Tipo de assunto"
                        v-model="assunto.uid_tipo_assunto"
                        :items="tpassunto"
                        clearable
                        outlined
                        dense
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      colls="12"
                      lg="10"
                      md="12"
                    >
                      <v-text-field
                        v-model="assunto.ds_assunto"
                        type="text"
                        label="Observação"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="assunto.id"
                  type="submit"
                  @click.prevent="saveAssunto()"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Atualizar
                </v-btn>
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="!assunto.id"
                  type="submit"
                  @click.prevent="saveAssunto()"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="error"
                  class="mr-4"
                  v-if="!assunto.id"
                  @click="clearAssunto"
                  v-show="mode === 'delAssunto'"
                >
                  deleter
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="FecharDialog"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>
        <!-- Dialog de subassunto -->
        <v-container>
          <v-dialog
            v-model="DialogSubAssunto"
            transition="dialog-top-transition"
            persistent
          >
            <v-card tile>
              <v-toolbar
                color="primary"
                dark
                class="mb-2"
              >
                Adicionar ou editar subassuntos
              </v-toolbar>
              <div class="logo-foto ml-4 mt-5">
                <v-form>
                  <input
                    id="user-id"
                    type="hidden"
                    v-model="subassunto.usuario"
                  />
                  <input
                    id="subassunto-id"
                    type="hidden"
                    v-model="subassunto.id"
                  />
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="code"
                        label="Código"
                        dense
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      colls="12"
                      lg="3"
                      md="4"
                      v-if="subassunto.id"
                    >
                      <v-checkbox
                        v-model="subassunto.inativar"
                        label="Inativar Subassunto?"
                        color="success"
                        class="mt-4"
                      >
                      </v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="5"
                      lg="4"
                    >
                      <v-text-field
                        v-model="subassunto.subassunto"
                        type="text"
                        label="Nome do subassunto"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      colls="12"
                      lg="4"
                      md="5"
                      sm="12"
                    >
                      <v-autocomplete
                        label="Assunto:"
                        v-model="subassunto.uid_assunto"
                        :items="assuntos"
                        clearable
                        dense
                        outlined
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      colls="12"
                      lg="10"
                      md="12"
                    >
                      <v-text-field
                        v-model="subassunto.ds_subassunto"
                        type="text"
                        label="Observação"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="subassunto.id"
                  type="submit"
                  @click.prevent="saveSubAssunto()"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Atualizar
                </v-btn>
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="!subassunto.id"
                  type="submit"
                  @click.prevent="saveSubAssunto()"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="error"
                  class="mr-4"
                  v-if="!subassunto.id"
                  @click="clearSubAssunto"
                  v-show="mode === 'delSubassunto'"
                >
                  deleter
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="FecharDialog"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>
        <!-- Dialog de situações -->
        <v-container>
          <v-dialog
            v-model="DialogSituacao"
            transition="dialog-top-transition"
            persistent
          >
            <v-card tile>
              <v-toolbar
                color="primary"
                dark
                class="mb-2"
              >
                Adicionar ou editar situações
              </v-toolbar>
              <div class="logo-foto ml-4 mt-5">
                <v-form>
                  <input
                    id="user-id"
                    type="hidden"
                    v-model="situacao.usuario"
                  />
                  <input
                    id="situacao-id"
                    type="hidden"
                    v-model="situacao.id"
                  />
                  <input
                    id="situacao-sessao"
                    type="hidden"
                    v-model="situacao.sessao"
                  />
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="code"
                        label="Código"
                        dense
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      colls="12"
                      lg="3"
                      md="4"
                      v-if="situacao.id"
                    >
                      <v-checkbox
                        v-model="situacao.inativar"
                        label="Inativar Situação?"
                        color="success"
                        class="mt-4"
                      >
                      </v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="5"
                      lg="4"
                    >
                      <v-text-field
                        v-model="situacao.situacao"
                        type="text"
                        label="Situacao"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      colls="12"
                      lg="3"
                      md="4"
                    >
                      <v-checkbox
                        v-model="situacao.restrita"
                        label="Situação restrita?"
                        color="success"
                        class="mt-4"
                      >
                      </v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      colls="12"
                      lg="10"
                      md="12"
                    >
                      <v-text-field
                        v-model="situacao.ds_situacao"
                        type="text"
                        label="Observação"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="situacao.id"
                  type="submit"
                  @click.prevent="saveSituacao()"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Atualizar
                </v-btn>
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="!situacao.id"
                  type="submit"
                  @click.prevent="saveSituacao()"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="error"
                  class="mr-4"
                  v-if="!situacao.id"
                  @click="clearSituacao"
                  v-show="mode === 'delSituacao'"
                >
                  deleter
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="FecharDialog"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>
        <!-- Dialog de anexo -->
        <v-container>
          <v-dialog
            v-model="DialogAnexo"
            transition="dialog-top-transition"
          >
            <v-card tile>
              <v-toolbar
                color="primary"
                dark
                class="mb-2"
              >
                Adicionar ou editar anexos ao processo
              </v-toolbar>
              <div class="logo-foto ml-4 mt-5">
                <v-form>
                  <input
                    id="user-id"
                    type="hidden"
                    v-model="anexo.usuario"
                  />
                  <input
                    id="uuid-id"
                    type="hidden"
                    v-model="anexo.uuid"
                  />
                  <input
                    id="anexo-id"
                    type="hidden"
                    v-model="anexo.id"
                  />
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="code"
                        label="Código"
                        dense
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      colls="12"
                      lg="3"
                      md="4"
                      v-if="anexo.id"
                    >
                      <v-checkbox
                        v-model="anexo.inativar"
                        label="Inativar Documento?"
                        color="success"
                        class="mt-4"
                      >
                      </v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                      lg="3"
                    >
                      <v-text-field
                        v-model="anexo.nome"
                        type="text"
                        label="Nome do arquivo"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      colls="12"
                      lg="3"
                      md="4"
                    >
                      <v-autocomplete
                        label="Tipo de documento:"
                        v-model="anexo.uid_tipodoc"
                        :items="tipoAnexo"
                        dense
                        outlined
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="5"
                      lg="4"
                    >
                      <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-mask="datanex"
                            v-model="data_anex"
                            label="Data de publicacao.:"
                            dense
                            outlined
                            @blur="mudaDataC"
                          >
                            <v-icon
                              slot="append"
                              color="success"
                              large
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-calendar
                            </v-icon>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          locale="pt-br"
                          v-model="date2"
                          @input="dateC"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row v-if="anexo.id">
                    <v-col
                      cols="12"
                      lg="8"
                    >
                      <v-text-field
                        v-model="anexo.url"
                        label="Limk do documento ou arquivo:"
                        class="mb-2"
                        :readonly="mode === 'delete'"
                        dense
                        outlined
                      >
                        <v-btn
                          icon
                          tile
                          color="success"
                          :href="anexo.url"
                          target="_blank"
                          append
                          slot="append"
                        >
                          <v-icon large>
                            mdi-file-download
                          </v-icon>
                        </v-btn>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="!anexo.id">
                    <input
                      accept="application/vnd.ms-excel, application/pdf"
                      prepend-icon="mdi-paperclip-plus"
                      label="Anexo"
                      v-if="uploadReady"
                      type="file"
                      ref="file"
                      @change="selectFile()"
                    >
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="anexo.id"
                  type="submit"
                  @click.prevent="updateDoc()"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Atualizar
                </v-btn>
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="!anexo.id"
                  type="submit"
                  @click.prevent="fileUpload()"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="error"
                  class="mr-4"
                  v-if="!anexo.id"
                  @click="clearUpload"
                >
                  deleter
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="FecharDialog"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>
        <!-- Dialog cadastro de pessoa -->
        <v-container>
          <v-dialog
            v-model="DialogPessoa"
            transition="dialog-top-transition"
          >
            <v-card tile>
              <v-toolbar
                color="primary"
                dark
                class="mb-2"
              >
                <v-icon large>
                  mdi-pencil-box-outline
                </v-icon>
                Adicionar interessado
              </v-toolbar>
              <v-form ref="form">
                <Cadastro :btnsair="btnsair" />
              </v-form>
              <v-card-actions class="justify-end">
                <v-btn
                  color="primary"
                  class="mr-4"
                  @click="FecharDialog"
                >
                  <v-icon
                    left
                    class="mr-3"
                  >mdi-close</v-icon>
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import { baseApiUrl, showError } from '@/global'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import axios from 'axios'
import moment from 'moment'
import Cadastro from '@/modules/admin/cadastros/pessoas'
export default {
  name: 'AutuacaoProcesso',
  components: { Cadastro },
  computed: mapState(['user']),

  data: function () {
    return {
      errors: {},
      editor: ClassicEditor,
      editorConfig: {
      },
      datacad: '##/##/####',
      datenc: '##/##/####',
      datanex: '##/##/####',
      mode: 'save',
      pagina: 'protocolo',
      tabela: 'anexosprocesso',
      tabs: null,
      code: '',
      codigo: '',
      btnsair: true,
      DialogPessoa: false,
      dialogFilter: false,
      dialogFilterOrigem: false,
      DialogAnexo: false,
      DialogAssunto: false,
      DialogSubAssunto: false,
      DialogSituacao: false,
      date0: new Date().toISOString().substr(0, 10),
      date1: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      data_cad: '',
      data_enc: '',
      data_anex: '',
      menu: false,
      menu1: false,
      menu2: false,
      search: null,
      uuid: '',
      uploadReady: true,
      file: '',
      proc: '',
      anoProc: '',
      uidProc: '',
      ementa: '',
      pessoa: {},
      interessado: {},
      origem: {},
      origens: [],
      itemsI: [],
      itemsA: [],
      listarI: '',
      listarA: '',
      processo: {},
      processos: [],
      anexo: {},
      ordens: [],
      tipoProjeto: [],
      autor: {},
      autores: [],
      anexos: [],
      tipoAnexo: [],
      assunto: {},
      subassunto: {},
      situacao: {},
      assuntos: [],
      subassuntos: [],
      situacoes: [],
      tipo: [],
      loading: false,
      filter: null,
      filterOn: [],
      localProcesso: [
        { value: 'origem-do-esic', text: 'Processos do eSic' },
        { value: 'origem-do-compras', text: 'Processo de compras' },
        { value: 'origem-de-projetos', text: 'Projetos de lei' }
      ],
      tpassunto: [
        { value: 'ATCID', text: 'Atend. cidadão' },
        { value: 'OVDOR', text: 'Ouvidoria' },
        { value: 'PROTO', text: 'Protocolo' },
        { value: 'JURID', text: 'Jurídico' },
        { value: 'E-SIC', text: 'e-Sic' }
      ],
      headersProc: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Processo', value: 'processo' },
        { text: 'Ano', value: 'ano' },
        { text: 'Processo de origem', value: 'processo_origem' },
        { text: 'Ano', value: 'ano_processo_origem' },
        { text: 'Projeto', value: 'projeto' },
        { text: 'Ano', value: 'ano' },
        { text: 'Data autuação', value: 'cadastro' },
        { text: 'Situação', value: 'situacao' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      headersOrig: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Título', value: 'titulo' },
        { text: 'Processo', value: 'processo' },
        { text: 'Ano', value: 'ano' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      headerAutor: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Autor ou interessado', value: 'autor' },
        { text: 'Situação', value: 'situacao' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      headerAnexo: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Sessão', value: 'uid_processo' },
        { text: 'Nome do arquivo', value: 'nome' },
        { text: 'Url', value: 'url' },
        { text: 'Tamanho', value: 'size' },
        { text: 'Ações', value: 'actions', sortable: false }
      ]
    }
  },
  methods: {
    mudaDataA () {
      const [dia, mes, ano] = this.data_cad.split('/')
      if (this.data_cad) {
        this.processo.data_criacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateA () {
      this.data_cad = moment(this.date0).format('DD/MM/YYYY')
      this.menu = false
      const [dia, mes, ano] = this.data_cad.split('/')
      this.processo.data_criacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataB () {
      const [dia, mes, ano] = this.data_enc.split('/')
      if (this.data_enc) {
        this.processo.data_encerramento = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateB () {
      this.data_enc = moment(this.date1).format('DD/MM/YYYY')
      this.menu1 = false
      const [dia, mes, ano] = this.data_enc.split('/')
      this.processo.data_encerramento = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataC () {
      const [dia, mes, ano] = this.data_anex.split('/')
      if (this.data_anex) {
        this.anexo.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateC () {
      this.data_anex = moment(this.date2).format('DD/MM/YYYY')
      this.menu2 = false
      const [dia, mes, ano] = this.data_anex.split('/')
      this.anexo.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    save () {
      const mode = this.mode
      const method = this.processo.id ? 'put' : 'post'
      const id = this.processo.id ? `/${this.processo.id}` : ''
      axios[method](`${baseApiUrl}/protocolo${id}`, this.processo)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          if (mode === 'save') {
            this.reset()
          }
        })
        .catch(showError)
    },
    saveAssunto () {
      const method = this.assunto.id ? 'put' : 'post'
      const id = this.assunto.id ? `/${this.assunto.id}` : ''
      axios[method](`${baseApiUrl}/assuntos-de-protocolo${id}`, this.assunto)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadAssunto()
          this.clearAssunto()
        })
        .catch(showError)
    },
    saveSubAssunto () {
      const method = this.subassunto.id ? 'put' : 'post'
      const id = this.subassunto.id ? `/${this.subassunto.id}` : ''
      axios[method](`${baseApiUrl}/subassuntos-de-protocolo${id}`, this.subassunto)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadSubassunto()
          this.clearSubAssunto()
        })
        .catch(showError)
    },
    saveSituacao () {
      const method = this.situacao.id ? 'put' : 'post'
      const id = this.situacao.id ? `/${this.situacao.id}` : ''
      axios[method](`${baseApiUrl}/situacoes${id}`, this.situacao)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadSituacoes()
          this.clearSituacao()
        })
        .catch(showError)
    },
    update () {
      const method = this.processo.id ? 'put' : 'post'
      const id = this.processo.id ? `/${this.processo.id}` : ''
      axios[method](`${baseApiUrl}/processo-do-dia-update${id}`, this.processo)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadProcesso()
        })
        .catch(showError)
    },
    updateDoc () {
      const method = this.anexo.id ? 'put' : 'post'
      const id = this.anexo.id ? `/${this.anexo.id}` : ''
      axios[method](`${baseApiUrl}/anexos-de-projetos${id}`, this.anexo)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.clearAnexo()
          this.loadAnexos()
        })
        .catch(showError)
    },
    remove () {
      if (confirm('Deseja realmente deletar este protocolo?')) {
      }
    },
    selectFile () {
      this.file = this.$refs.file.files[0]
    },
    async fileUpload () {
      const formData = new FormData()
      const method = this.anexo.id ? 'put' : 'post'
      const id = this.anexo.id ? `/${this.anexo.id}` : ''
      const url = `${baseApiUrl}/upload-documentos-em-anexo-do-projeto${id}`
      formData.append('uid_processo', this.processo.id)
      formData.append('nome', this.anexo.nome)
      formData.append('tabela', this.tabela)
      formData.append('pasta', this.processo.ano)
      formData.append('subpasta', this.processo.id)
      formData.append('uid_tipodoc', this.anexo.uid_tipodoc)
      formData.append('data_publicacao', this.anexo.data_publicacao)
      formData.append('usuario', this.user.id)
      formData.append('file', this.file)
      await axios[method](url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetUpload()
          this.loadAnexos()
        })
        .catch(showError)
    },
    clearUpload () {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    clearUpCampos () {
      this.anexo = {}
      this.file = ''
    },
    resetUpload () {
      this.anexo = {}
      this.file = ''
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    reset () {
      this.mode = 'save'
      this.code = ''
      this.codigo = ''
      this.proc = ''
      this.processo = {}
      this.data_cad = ''
      this.data_enc = ''
      this.ementa = ''
      this.autores = []
      this.anexos = []
      this.tipoAnexo = []
      this.processo.usuario = this.user.id
      this.processo.uuid = uuid.v1()
    },
    loadProcesso (item, mode) {
      const mod = mode || this.mode
      const id = this.codigo ? this.codigo : item.processo
      const url = `${baseApiUrl}/protocolo-update/${id}`
      axios.get(url).then(res => {
        this.processo = res.data
        this.code = this.processo.id
        this.codigo = this.processo.processo
        this.uid_proc_orig = this.processo.uid_proc_orig
        this.proc = this.processo.processo_origem
        this.anoProc = this.processo.ano_processo_origem
        this.ementa = this.processo.ds_protocolo
        if (!this.processo.data_criacao) {
          this.data_cad = ''
        } else {
          this.data_cad = moment(this.processo.data_criacao).format('DD/MM/YYYY')
          this.processo.data_criacao = moment(this.processo.data_criacao).format('YYYY-MM-DD')
        }
        //        this.loadAnexos()
      })
      this.mode = mod
      this.dialogFilter = false
    },
    loadOrigem (item) {
      const cm = this.processo.local
      const id = this.proc ? this.proc : item.processo
      const url = `${baseApiUrl}/${cm}/${id}`
      axios.get(url).then(res => {
        this.origem = res.data
        this.proc = this.origem.processo
        this.anoProc = this.origem.ano
        this.uidProc = this.origem.id
        this.ementa = this.origem.ds_projeto
        this.processo.processo_origem = this.proc
        this.processo.ano_processo_origem = this.anoProc
        this.processo.uid_proc_orig = this.uidProc
        this.processo.ds_protocolo = this.ementa
      })
      this.dialogFilterOrigem = false
    },
    loadPedidoPessoaId (item) {
      const id = this.processo.autor ? `/${this.processo.autor}` : `/${item.uid_pessoa}`
      const url = `${baseApiUrl}/pessoas-por-idd${id}`
      axios.get(url).then(res => {
        this.pessoa = res.data
        this.processo.uid_autor = this.pessoa.uid_pessoa
        this.processo.autor = this.pessoa.razao
      })
      this.clPessoa()
    },
    loadInteressadoPessoaId (item) {
      const id = this.processo.uid_interessado ? `/${this.processo.uid_interessado}` : `/${item.uid_pessoa}`
      const url = `${baseApiUrl}/pessoas-por-idd${id}`
      axios.get(url).then(res => {
        this.interessado = res.data
        this.processo.uid_interessado = this.interessado.uid_pessoa
        this.processo.interessado = this.interessado.razao
      })
      this.clInteressado()
    },
    loadAutorPessoaId (item) {
      const id = this.processo.uid_autor ? `/${this.processo.uid_autor}` : `/${item.uid_pessoa}`
      const url = `${baseApiUrl}/pessoas-por-idd${id}`
      axios.get(url).then(res => {
        this.pessoa = res.data
        this.processo.uid_autor = this.pessoa.uid_pessoa
        this.processo.autor = this.pessoa.razao
      })
      this.clAutor()
    },
    loadFtAutor () {

    },
    clInteressado () {
      this.interessado = {}
      this.itemsI = []
      this.processo.uid_interessado = ''
      this.processo.interessado = ''
      this.listarI = ''
    },
    clAutor () {
      this.pessoa = {}
      this.itemsA = []
      this.processo.uid_autor = ''
      this.processo.autor = ''
      this.listarA = ''
    },
    clearAssunto () {
      this.assunto = {}
      this.assunto.usuario = this.user.id
    },
    clearSubAssunto () {
      this.subassunto = {}
      this.subassunto.usuario = this.user.id
    },
    clearSituacao () {
      this.situacao = {}
      this.situacao.usuario = this.user.id
      this.situacao.sessao = 'protocolo'
    },
    loadAddPessoa () {
      this.assunto = {}
      this.DialogPessoa = true
    },
    loadFtPessoa () {

    },
    loadAddAssunto () {
      this.DialogAssunto = true
      this.assunto.usuario = this.user.id
    },
    loadAddSubassunto () {
      this.DialogSubAssunto = true
      this.subassunto.usuario = this.user.id
    },
    loadAddSituacao () {
      this.DialogSituacao = true
      this.situacao.usuario = this.user.id
      this.situacao.sessao = 'protocolo'
    },
    loadSeachI (listarI = 'sim') {
      const search = this.processo.interessado || 0
      const url = `${baseApiUrl}/pessoas-por-nome/${search}`
      axios.get(url).then(res => {
        this.itemsI = res.data
      })
      this.listarI = listarI
    },
    loadSeachA (listarA = 'sim') {
      const search = this.processo.autor || 0
      const url = `${baseApiUrl}/pessoas-por-nome/${search}`
      axios.get(url).then(res => {
        this.itemsA = res.data
      })
      this.listarA = listarA
    },
    loadModalAnexo () {
      this.anexo.usuario = this.user.id
      this.anexo.uuid = uuid.v1()
      this.DialogAnexo = true
      this.loadTipoAnexo()
    },
    FecharDialog () {
      this.DialogAnexo = false
      this.DialogAssunto = false
      this.DialogSubAssunto = false
      this.DialogSituacao = false
      this.DialogPessoa = false
      this.clearAssunto()
      this.clearSubAssunto()
      this.clearSituacao()
    },
    loadDialog () {
      this.dialogFilter = true
      this.loadFilter()
      this.codigo = ''
    },
    loadDialogOrigem () {
      this.dialogFilterOrigem = true
      this.loadFilterOrigem()
      this.proc = ''
    },
    loadFilter () {
      const url = `${baseApiUrl}/protocolo-filtro`
      axios.get(url).then(res => {
        this.processos = res.data.map(item => {
          return {
            ...item,
            cadastro: moment(item.data_criacao).format('DD/MM/YYYY'),
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadFilterOrigem () {
      const cm = this.processo.local
      const url = `${baseApiUrl}/${cm}-filtro`
      axios.get(url).then(res => {
        this.origens = res.data
      })
    },
    loadAnexos () {
      const id = this.processo.id
      const url = `${baseApiUrl}/anexos-de-processos-por-uid/${id}`
      axios.get(url).then(res => {
        this.anexos = res.data
      })
    },
    loadAnexo (items, mode) {
      const id = items.id
      const url = `${baseApiUrl}/anexos-de-projetos-up/${id}`
      axios.get(url).then(res => {
        this.anexo = res.data
        if (!this.anexo.data_publicacao) {
          this.data_anex = ''
        } else {
          this.data_anex = moment(this.anexo.data_publicacao).format('DD/MM/YYYY')
          this.anexo.data_publicacao = moment(this.anexo.data_publicacao).format('YYYY-MM-DD')
        }
      })
      this.mode = mode
      this.DialogAnexo = true
      this.loadTipoAnexo()
    },
    loadTipoAnexo () {
      const url = `${baseApiUrl}/categoria-de-documentos`
      axios.get(url).then(res => {
        this.tipoAnexo = res.data.map(item => {
          return {
            value: item.id,
            text: `${item.cat_doc}`
          }
        })
      })
    },
    loadAssunto () {
      const url = `${baseApiUrl}/assuntos-de-protocolo`
      axios.get(url).then(res => {
        this.assuntos = res.data.map(item => {
          return {
            value: item.id,
            text: `${item.assunto}`
          }
        })
      })
    },
    loadSubassunto () {
      const id = this.processo.uid_assunto
      const url = `${baseApiUrl}/subassuntos-de-assunto/${id}`
      axios.get(url).then(res => {
        this.subassuntos = res.data.map(item => {
          return {
            value: item.id,
            text: `${item.subassunto}`
          }
        })
      })
    },
    loadSituacoes () {
      const id = this.pagina
      const url = `${baseApiUrl}/situacoes-por-processo/${id}`
      axios.get(url).then(res => {
        this.situacoes = res.data.map(item => {
          return {
            value: item.id,
            text: `${item.situacao}`
          }
        })
      })
    },
    loadUsers () {
      this.processo.usuario = this.user.id
      this.processo.uuid = uuid.v1()
    }
  },
  watch: {
    Filter () {
      // this.loadFilter()
    }
  },
  created () {
    this.loadUsers()
    this.loadAssunto()
    this.loadSituacoes()
  }
}
</script>
<style scoped>
.form-tabs {
  background-color: #f0eceaf3;
}
.text-v-card {
  font-size: 1rem !important;
}
.code {
  max-width: 100% !important;
}
.v-busca-nome {
  max-width: 100% !important;
  height: 45px !important;
}
.v-input__prepend-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}
.btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
}
.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -11px !important;
}
.v-size--default {
  height: 37px !important;
  min-width: 38px !important;
}
ul.filtro {
  position: absolute;
  min-width: 350px;
  top: 0px;
  left: 40px;
  padding: 2px 6px !important;
  background-color: #feffff;
  border: solid 1px #000;
  list-style: none;
  z-index: 1000;
}
ul.filtro li a {
  text-decoration: none;
  color: #333 !important;
}
ul.filtro li:hover {
  background-color: teal;
  color: #ffffff !important;
}
ul.filtro li a:hover {
  color: #ffffff !important;
}
</style>
